import { render, staticRenderFns } from "./OpsiyonTanimla.vue?vue&type=template&id=46248de9&scoped=true&"
import script from "./OpsiyonTanimla.vue?vue&type=script&lang=js&"
export * from "./OpsiyonTanimla.vue?vue&type=script&lang=js&"
import style0 from "./OpsiyonTanimla.vue?vue&type=style&index=0&id=46248de9&scoped=true&lang=css&"
import style1 from "./OpsiyonTanimla.vue?vue&type=style&index=1&id=46248de9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46248de9",
  null
  
)

export default component.exports